export type PlayEngineVersion = "catie_1_0" | "catie_2_1" | "catie_3_0";

export const DEFAULT_PLAY_ENGINE_VERSION: PlayEngineVersion = "catie_2_1";

export const playEngineVersions: PlayEngineVersion[] = ["catie_1_0", "catie_2_1", "catie_3_0"];

const STORAGE_KEY = "catiechess.play.engineVersion";

export function isPlayEngineVersion(value: string | null): value is PlayEngineVersion {
  return value === "catie_1_0" || value === "catie_2_1" || value === "catie_3_0";
}

export function getStoredPlayEngineVersion(): PlayEngineVersion {
  if (typeof window === "undefined") {
    return DEFAULT_PLAY_ENGINE_VERSION;
  }
  const stored = window.localStorage.getItem(STORAGE_KEY);
  return isPlayEngineVersion(stored) ? stored : DEFAULT_PLAY_ENGINE_VERSION;
}

export function storePlayEngineVersion(value: PlayEngineVersion) {
  if (typeof window === "undefined") {
    return;
  }
  window.localStorage.setItem(STORAGE_KEY, value);
}
